export const enum REACTIVATION_SOURCE {
  DASHBOARD = 'dashboard',
  SETTINGS = 'planSettings',
  PLAN_BANNER = 'planBanner',
}
